import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, Button, cls } from '../../packages/components';
import './styles/AAFModalBidirectionalServices.css';

const AAFModalBidirectionalServices = (props = {}) => {
    const Contentservices = () => {
        return (
            <Row className={props.device}>
                {props.options.map((y) => {
                    return (
                        <Column lg={3} key={y.id}>
                            <Button
                                activate
                                type="button"
                                className={cls('focusable', 'modal-button-services')}
                                onClick= {(e) => props.handleClose(e, props.service(y.id))}>
                                    <span>{y.name}<br/>{y.id}</span>
                            </Button>
                        </Column>
                    );
                })}
            </Row>
        );
    };
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: false,
    };
    return (
        <ModalWrapper {...p}>
            <Contentservices />
        </ModalWrapper>
    );
};

AAFModalBidirectionalServices.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalBidirectionalServices);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalHubBidirectionalServices.jsx